<template>
	<div class="cog-abuse cog-wrapper">
		<hr>
		<ul>
			<li><a target="_blank" :href="reportAbuseUrl">{{ $resource("public-report-abuse-link-text") }}</a></li>
			<li><a target="_blank" :href="baseUrl + 'terms'">{{ $resource("public-terms-of-service-link-text") }}</a></li>
		</ul>
	</div>
</template>

<script>
	import { getSiteUrl } from 'src/util/site-url';
	export default {
		name: 'CAbuse',
		inject: ['$resource'],
		computed: {
			baseUrl() {
				return getSiteUrl();
			},
			reportAbuseUrl() {
				return `${this.baseUrl}reportabuse?form=${encodeURIComponent(location.origin + location.pathname)}`;
			}
		}
	};
</script>

<style lang="scss">
#{$specificity-base} {

	.cog-abuse {
		padding-top: var(--gutter);

		@media print {
			display: none;
		}

		ul {
			display: block;
			margin: 0;
			padding: 10px 0 0;
			font-size: 11px;
			text-align: center;
		}

		li {
			display: inline-block;
			list-style: none;
		}

		li + li {
			border-left: var(--border-width) solid hsla(var(--background-hsl), .3);
			margin-left: .4em;
			padding-left: .7em;
		}

		a {
			display: inline-block;
			border-bottom: var(--border-width) solid transparent;
			padding: .1em 0;
			color: var(--color);
			text-decoration: none;
			transition: all $speed-quarter;

			&:hover {
				border-bottom-color: hsla(var(--background-hsl), .4);
			}

			&:focus {
				border-bottom-color: var(--highlight);
			}
		}
	}
}
</style>